export const WHY_US = "/why_us"
export const CAREERS = "/careers"
export const CONTACT_US = "/contact_us"
export const CONTACT = "/contact"
export const TRACK = "/track_your_parcel"
export const FAQ = "/faq"
export const TERMS_AND_CONDITIONS = "/terms_and_conditions"
export const PRIVACY_POLICY = "/privacy_policy"
